<template>
    <div>

        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Identificação do paciente"
            >
                <FormCidadao
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Profissional responsável"
                show-legend
            >
                <FormProfissional
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Atendimento"
            >
                <FormAtendimento
                    :data="{ form, model }"
                />
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Motivo da visita"
            >
                <FormMotivo
                    :data="{ form, model }"
                />
            </rkm-area>

            <FormComplemento
                :data="{ form, model }"
            />
        </rkm-form>
    </div>
</template>

<script>

// Mixins
import { repository, stringCase, data, object, formats, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

// Components
import FormCidadao from '@/components/atencao-basica/visita-domiciliar/components/cidadao/Form.vue'
import FormProfissional from '@/components/atencao-basica/visita-domiciliar/components/profissional/Form.vue'
import FormAtendimento from '@/components/atencao-basica/visita-domiciliar/components/atendimento/Form.vue'
import FormMotivo from '@/components/atencao-basica/visita-domiciliar/components/motivo/Form.vue'
import FormComplemento from '@/components/atencao-basica/visita-domiciliar/components/complemento/Form.vue'


export default {
    components: {
        FormCidadao,
        FormProfissional,
        FormAtendimento,
        FormMotivo,
        FormComplemento,
    },
    computed: {
        validations() {

            return {
                complemento: { max: 1000 },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
            }
        },
    },
    created() {

        this.repositories = {
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar')
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: {},
        model: {},
        loaded: false,
        residentes: []
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.visitaDomiciliar.show(this.item.id)
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)
                    this.form = Object.assign(response.data.form)

                    this.model.cadastro = this.data.model.cadastro
                    this.model.atendimento.turnoId = this.data.model.atendimento.turnoId
                    this.model.atendimento.imovelTipoId = this.data.model.atendimento.imovelTipoId
                    this.model.atendimento.latitude = this.data.model.atendimento.latitude
                    this.model.atendimento.longitude = this.data.model.atendimento.longitude
                    this.model.atendimento.visitaCompartilhada = this.data.model.atendimento.visitaCompartilhada

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async save() {
            const valid = await this.$refs.Form.validate()
            if (!valid) return

                this.setLoading()

                this.repositories.visitaDomiciliar.store(this.prepareData())
                    .then(response => {

                        this.showSaveNotification()
                        this.$emit('closeModal', response.data)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        prepareData() {

            const pacienteId = this.model.cidadao.pacienteId
            const cadastro = this.clone(this.model.cadastro)

            cadastro.usuarioId = cadastro.usuario.id
            cadastro.dataUsuarioResponsavel = this.getFormatedDate(cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD')

            const atendimento = this.clone(this.model.atendimento)
            const complemento = this.clone(this.model.complemento)
            const motivo = this.clone(this.model.motivo)

            return this.camelObjectKeysToSnakeRecursive({
                pacienteId, cadastro, atendimento, motivo, complemento
            })
        },
        closeModal() {
            this.$emit('save')
        }
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: Number, default: null },
        pacienteId: { type: Number, default: null },
        item: { type: Object, default: null },
        data: { type: Object, required: false },
    },
}
</script>